import React from 'react';
import { motion } from 'framer-motion';
import { X, Book } from 'lucide-react';

const ItemSelectionModal = ({ isOpen, onClose, onSelect, items, bookTitle }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[70] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm lg:pl-72">
            <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.95 }}
                className="bg-background border border-border rounded-2xl w-full max-w-lg shadow-2xl overflow-hidden"
            >
                <div className="p-4 border-b border-border flex items-center justify-between bg-muted/50">
                    <h3 className="text-lg font-bold text-foreground">Choisir l'exemplaire</h3>
                    <button onClick={onClose} className="text-muted-foreground hover:text-foreground transition-all">
                        <X size={20} />
                    </button>
                </div>

                <div className="p-6">
                    <p className="text-muted-foreground mb-4">
                        Plusieurs exemplaires sont disponibles pour "<strong>{bookTitle}</strong>".
                        Veuillez sélectionner l'ID du livre que vous remettez au membre :
                    </p>

                    <div className="space-y-3 max-h-[40vh] overflow-y-auto pr-2">
                        {items && items.map((item) => (
                            <button
                                key={item.item_id || item.id}
                                onClick={() => onSelect(item)}
                                className="w-full flex items-center justify-between p-4 rounded-xl border border-border bg-muted/30 hover:bg-primary/10 hover:border-primary/50 transition-all group"
                            >
                                <div className="flex items-center gap-3">
                                    <div className="p-2 bg-primary/20 rounded-lg text-primary">
                                        <Book size={18} />
                                    </div>
                                    <div className="text-left">
                                        <div className="font-bold text-foreground">ID: {item.item_id || item.id}</div>
                                        <div className="text-xs text-muted-foreground">{item.emplacement || item.location || 'Pas d\'emplacement'}</div>
                                    </div>
                                </div>
                                <div className={`px-2 py-1 rounded-md text-[10px] uppercase font-bold ${item.status === 'Disponible' ? 'bg-emerald-500/20 text-emerald-400' :
                                    item.status === 'Réservé' ? 'bg-amber-500/20 text-amber-400' :
                                        'bg-red-500/20 text-red-100'
                                    }`}>
                                    {item.status}
                                </div>
                            </button>
                        ))}
                    </div>
                </div>

                <div className="p-4 bg-muted/50 border-t border-border flex justify-end">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 text-sm font-medium text-muted-foreground hover:text-foreground transition-all"
                    >
                        Annuler
                    </button>
                </div>
            </motion.div>
        </div>
    );
};

export default ItemSelectionModal;
